import { Checkbox, Divider, FormControlLabel, Grid, TextField, Typography, InputLabel, Select, MenuItem, ListItemText, Box, Chip, FormControl } from "@mui/material"
import { Controller, useFormContext } from "react-hook-form"
import SelectPerfil from "../../../../../components/SelectsSimpleApiQuery/SelectPerfil"
import { FormConfigFluxo } from ".";

export default function FormConfiguracoes({ tarefas }: IFormConfiguracoes) {

    const { control, watch, setValue } = useFormContext<FormConfigFluxo>();

    const modulo = [
        "Estoque",
        "Financeiro",
        "Comercial",
        "Fiscal",
        "Café",
        "Cadastros",
        "Receituário agronômico",
        "Fabrica"
    ];

    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
                <Controller
                    name="nome"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            {...field}
                            label="Nome"
                            disabled
                            fullWidth
                        />
                    )}
                />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
                <Controller
                    name="versao"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            {...field}
                            label="Versão"
                            disabled
                            fullWidth
                        />
                    )}
                />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
                <Controller
                    name="status"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            {...field}
                            label="Status"
                            disabled
                            fullWidth
                        />
                    )}
                />
            </Grid>

            <Grid size={{ xs: 12 }}>
                <Divider />
                <Typography variant="subtitle1" mt={1}>Configurações avançadas</Typography>
            </Grid>


            <Controller
                name="modulo"
                control={control}
                render={({ field }) => (
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Modulo</InputLabel>
                        <Select
                            {...field}
                            value={field.value}
                            onChange={(event) => {
                                field.onChange(event.target.value);
                            }}
                            label="Modulo"
                        >
                            {modulo.map((modulo) => (
                                <MenuItem key={modulo} value={modulo}>
                                    {modulo}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
            />


            <Grid size={{ xs: 12 }}>
                <Controller
                    name="possui_data_expiracao"
                    control={control}
                    render={({ field }) => (
                        <FormControlLabel
                            sx={{ mb: 1 }}
                            control={
                                <Checkbox
                                    {...field}
                                    checked={field.value}
                                />
                            }
                            label={
                                <Typography variant="subtitle2" color="text.secondary">
                                    Possui data de expiração?
                                </Typography>
                            }
                        />
                    )}
                />

                <Controller
                    name={`dias_expiracao`}
                    rules={{ required: watch("possui_data_expiracao") ? 'Dias de expiração é obrigatório' : false }}
                    control={control}
                    render={({ field, fieldState: { error, invalid } }) => (
                        <TextField
                            {...field}
                            label="Dias até expiração"
                            fullWidth
                            type="number"
                            slotProps={{ htmlInput: { min: 0 } }}
                            disabled={!watch("possui_data_expiracao")}
                            error={invalid}
                            helperText={invalid ? error?.message : ''}
                        />
                    )}
                />
            </Grid>

            <Grid size={{ xs: 12 }}>
                <Controller
                    name="sem_perfil_solicitante"
                    control={control}
                    render={({ field }) => (
                        <FormControlLabel
                            sx={{ mb: 1 }}
                            control={
                                <Checkbox
                                    {...field}
                                    checked={field.value}
                                />
                            }
                            label={
                                <Typography variant="subtitle2" color="text.secondary">
                                    Sem perfil solicitante
                                </Typography>
                            }
                        />
                    )}
                />

                <Controller
                    name="perfil_solicitante"
                    control={control}
                    render={({ field }) => (
                        <SelectPerfil
                            value={field.value}
                            onChange={(value) => {
                                field.onChange(value);
                                setValue("perfil_solicitante", value);
                            }}
                            disabled={watch("sem_perfil_solicitante")}
                        />
                    )}
                />
            </Grid>

            <Grid size={{ xs: 12 }}>
                <Controller
                    name="bloquear_anexo_processo"
                    control={control}
                    render={({ field }) => (
                        <FormControlLabel
                            sx={{ mb: 1 }}
                            control={
                                <Checkbox
                                    {...field}
                                    checked={field.value}
                                />
                            }
                            label={
                                <Typography variant="subtitle2" color="text.secondary">
                                    Bloquear envio de anexo do processo
                                </Typography>
                            }
                        />
                    )}
                />

                <Controller
                    name="bloquear_anexo_tarefas"
                    control={control}
                    render={({ field }) => (
                        <FormControl
                            fullWidth
                            disabled={watch("bloquear_anexo_processo")}
                            sx={{ mb: 2 }}
                        >
                            <InputLabel>Bloquear anexo do processo na(s) tarefa(s)</InputLabel>
                            <Select
                                {...field}
                                multiple
                                value={field.value}
                                onChange={(event) => {
                                    const value = event.target.value;
                                    field.onChange(typeof value === 'string' ? value.split(',') : value);
                                }}
                                label="Bloquear anexo do processo na(s) tarefa(s)"
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {(selected as string[]).map((value) => {
                                            const tarefa = tarefas.find(t => t.id === value);
                                            return (
                                                <Chip
                                                    key={value}
                                                    label={tarefa?.titulo || value}
                                                    size="small"
                                                />
                                            );
                                        })}
                                    </Box>
                                )}
                            >
                                {tarefas.map((tarefa) => {
                                    const isSelected = (field.value).includes(String(tarefa.id));

                                    return (
                                        <MenuItem key={tarefa.id} value={String(tarefa.id)}>
                                            <Checkbox
                                                checked={isSelected}
                                            />
                                            <ListItemText
                                                primary={tarefa.titulo}
                                                primaryTypographyProps={{
                                                    variant: "body2"
                                                }}
                                            />
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    )}
                />

            </Grid>
        </Grid>
    )
}

interface IFormConfiguracoes {
    tarefas: {
        id: string;
        titulo: string;
    }[];
}